"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports["default"] = void 0;

var _scale = _interopRequireDefault(require("./scale"));
/**
 * Get run descent
 *
 * @param  {Object}  run
 * @return {number} descent
 */


var descent = function descent(run) {
  var _run$attributes, _run$attributes$font;

  var fontDescent = ((_run$attributes = run.attributes) === null || _run$attributes === void 0 ? void 0 : (_run$attributes$font = _run$attributes.font) === null || _run$attributes$font === void 0 ? void 0 : _run$attributes$font.descent) || 0;
  return (0, _scale["default"])(run) * fontDescent;
};

var _default = descent;
exports["default"] = _default;